import clsx from 'clsx'
import { ButtonHTMLAttributes, DetailedHTMLProps, FC, ReactNode } from 'react'
import { Link } from 'react-router-dom'

type IProps = DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> & {
  children: ReactNode
  classes?: string
  path?: string
}

const SecendaryButton: FC<IProps> = ({ children, classes, path, ...props }) => {
  return path ? (
    <Link to={path}>
      <button
        className={clsx(
          classes,
          'px-4 py-2 rounded-lg text-sm duration-300 ease-in-out hover:border-red-400 hover:text-red-400 border border-transparent hover:border',
        )}
        {...props}
      >
        {children}
      </button>
    </Link>
  ) : (
    <button
      className={clsx(
        classes,
        'px-4 py-2 rounded-lg text-sm duration-300 ease-in-out hover:border-red-400 hover:text-red-400 border border-transparent hover:border',
      )}
      {...props}
    >
      {children}
    </button>
  )
}

export default SecendaryButton
